import script from './SdsFlag.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sds-flag",class:( _obj = {}, _obj[("sds-flag--" + _vm.size)] = !!_vm.size, _obj )},[_c('CustomImage',{staticClass:"sds-flag__picture",attrs:{"src":("" + _vm.flagPath + (encodeURI(_vm.flagName)))}}),_vm._v(" "),(_vm.iconName)?_c('SdsIcon',{staticClass:"sds-flag__icon",attrs:{"isThemed":true,"size":"sm","iconName":_vm.iconName}}):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-4de0afd8_0", { source: ".sds-flag[data-v-4de0afd8]{position:relative}.sds-flag--sm[data-v-4de0afd8]{width:16px;height:16px}.sds-flag--sm .sds-flag__icon[data-v-4de0afd8]{bottom:-6px;right:-5px}.sds-flag--md[data-v-4de0afd8]{width:20px;height:20px}.sds-flag--md .sds-flag__icon[data-v-4de0afd8]{bottom:-6px;right:-5px}.sds-flag--lg[data-v-4de0afd8]{width:24px;height:24px}.sds-flag--lg .sds-flag__icon[data-v-4de0afd8]{bottom:-5px;right:-3px}.sds-flag__picture[data-v-4de0afd8]{width:inherit;height:inherit}.sds-flag__picture[data-v-4de0afd8] img{width:inherit;height:inherit;border-radius:50%;border:1px solid var(--system-border-on-elevation-tertiary)}.sds-flag__icon[data-v-4de0afd8]{position:absolute;width:16px;height:16px}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-4de0afd8";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
